import { render, staticRenderFns } from "./ChooseSectorsPage.vue?vue&type=template&id=2006c9ff&scoped=true&"
import script from "./ChooseSectorsPage.vue?vue&type=script&lang=ts&"
export * from "./ChooseSectorsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseSectorsPage.vue?vue&type=style&index=0&id=2006c9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006c9ff",
  null
  
)

export default component.exports